<template>
  <div>
    <el-card class="box-card" v-if="showchart">
        <div class="title">训练时长示意图</div>
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="71px" class="mt20">
            <el-form-item label="佩戴时间">
              <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" class="mr15"></el-date-picker>
              <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="clicksearch">查询</el-button>
                <el-button type="info" @click="backTrainingDataAnalysis">返回</el-button>
            </el-form-item>
        </el-form>
        <div>累计佩戴时长：{{Youxiaotime}}分钟，累计干预次数：{{Ganyunum}}</div>
        <!-- <div>开始区间(上下限)：{{localBeginsection}}，开始速度：{{localBeginspeed}}，结束区间(上下限)：{{localEndsection}}，结束速度：{{localEndspeed}}</div> -->
        <ve-line :data="chartData" :events="chartEvents"></ve-line>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    this.chartSettings = {
      metrics: ['佩戴总时长']
    }
    var self = this
    this.chartEvents = {
      click: function (e) {
        self.localBeginsection = self.dataList[e.dataIndex].Beginsection
        self.localBeginspeed = self.dataList[e.dataIndex].Beginspeed
        self.localEndsection = self.dataList[e.dataIndex].Endsection
        self.localEndspeed = self.dataList[e.dataIndex].Endspeed
      }
    }
    return {
      keywords: {
        begintime: '',
        endtime: ''
      },
      chartData: {
        columns: ['统计日期', '佩戴总时长'],
        rows: []
      },
      dataList: [],
      Youxiaotime: 0,
      Ganyunum: 0,
      localBeginsection: '',
      localBeginspeed: '',
      localEndsection: '',
      localEndspeed: '',
      showchart: false,
      parentdata: null
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.showchart = true
      this.apigetGanyuHeJujian()
    },
    backTrainingDataAnalysis () {
      this.showchart = false
      this.$emit('triggerFunc', '')
    },
    clicksearch () {
      this.apigetGanyuHeJujian()
    },
    apigetGanyuHeJujian: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetGanyuHeJujian, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            // that.chartData.rows = response.data.List
            that.chartData.rows = []
            response.data.List.filter((item1, i1) => {
              that.chartData.rows.push({ 统计日期: item1.Tongjitime, 佩戴总时长: item1.Totaltime })
            })

            that.Youxiaotime = response.data.Youxiaotime
            that.Ganyunum = response.data.Ganyunum
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
